/**
 * FAQs Accordion
 */

window.addEventListener("load", function () {
	const faqItems = document.querySelectorAll(".faqs__list-item");

	faqItems.forEach((item) => {
		item.addEventListener("click", function () {
			item.classList.add("show-answer");
		});
	});
});
